var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 24,
    viewBox: "0 0 61 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11076 6.5H1.11035V17.5C1.11035 19.0188 2.34157 20.25 3.86035 20.25H21.1395C22.6583 20.25 23.8895 19.0188 23.8895 17.5V6.50032L1.11076 6.5Z",
    fill: "#FFB357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5295 10.1397C15.4609 9.07113 14.0115 8.47076 12.5002 8.47076C10.9889 8.47076 9.5396 9.07113 8.47095 10.1397L1.11035 17.5C1.11035 19.0188 2.34157 20.25 3.86035 20.25H21.1395C22.6583 20.25 23.8895 19.0188 23.8895 17.5L16.5295 10.1397Z",
    fill: "#FFCE71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93743 17.5V13.6731H1.11035V17.5C1.11035 19.0188 2.34157 20.25 3.86035 20.25H7.68743C6.16865 20.25 4.93743 19.0188 4.93743 17.5Z",
    fill: "#FFB357"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1392 3.75H3.86035C2.34157 3.75 1.11035 4.98122 1.11035 6.5L8.47082 13.8605C9.53942 14.9291 10.9888 15.5295 12.5001 15.5295C14.0113 15.5295 15.4607 14.9291 16.5293 13.8605L23.8895 6.5C23.8895 4.98104 22.6582 3.75 21.1392 3.75Z",
    fill: "#FCE3A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93743 10.3269V6.5C4.93743 4.98122 6.16865 3.75 7.68743 3.75H3.86035C2.34157 3.75 1.11035 4.98122 1.11035 6.5L4.93725 10.3269H4.93743Z",
    fill: "#FFCE71"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_171_11762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9694 18.9277L44.2756 19.1087C45.5613 19.8703 47.0356 20.2732 48.539 20.2739H48.5422C53.1591 20.2739 56.9166 16.5245 56.9185 11.916C56.9193 9.68285 56.0489 7.58283 54.4674 6.00312C53.6917 5.22406 52.7689 4.60629 51.7524 4.18558C50.7359 3.76487 49.6459 3.54958 48.5455 3.55216C43.9249 3.55216 40.1673 7.3012 40.1657 11.9093C40.1634 13.4829 40.6074 15.025 41.4462 16.3573L41.6455 16.6733L40.7992 19.7573L43.9694 18.9277ZM38.3794 22.1464L39.8093 16.9358C38.9274 15.4109 38.4635 13.681 38.464 11.9087C38.4664 6.36418 42.9871 1.85352 48.5423 1.85352C51.2381 1.85488 53.7684 2.90196 55.6714 4.80266C57.5744 6.70336 58.6214 9.22979 58.6204 11.9167C58.618 17.4608 54.0966 21.9723 48.5422 21.9723H48.5378C46.8512 21.9716 45.194 21.5493 43.7219 20.7482L38.3794 22.1464Z",
    fill: "#B3B3B3"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2759 22.0431L39.7057 16.8325C38.8224 15.3039 38.3584 13.5699 38.3605 11.8053C38.3629 6.26085 42.8835 1.75018 48.4388 1.75018C51.1346 1.75155 53.6649 2.79862 55.5679 4.69933C57.4708 6.60003 58.5179 9.12646 58.5169 11.8134C58.5144 17.3575 53.9931 21.8689 48.4387 21.8689H48.4343C46.7477 21.8683 45.0905 21.446 43.6184 20.6448L38.2759 22.0431Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4418 3.44881C43.8213 3.44881 40.0637 7.19786 40.062 11.806C40.0597 13.3795 40.5037 14.9216 41.3426 16.2539L41.5419 16.5701L40.6955 19.6541L43.8659 18.8244L44.1721 19.0054C45.4578 19.767 46.9321 20.1697 48.4355 20.1706H48.4387C53.0556 20.1706 56.8132 16.4211 56.815 11.8127C56.8185 10.7143 56.6037 9.62612 56.1829 8.61116C55.7622 7.5962 55.1439 6.67462 54.3639 5.89978C53.5882 5.1207 52.6653 4.50292 51.6488 4.08221C50.6323 3.6615 49.5423 3.44622 48.4418 3.44881Z",
    fill: "url(#paint0_linear_171_11762)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9201 7.60157C45.7313 7.1831 45.5327 7.17462 45.3534 7.16738L44.8707 7.1615C44.7028 7.1615 44.43 7.22439 44.1993 7.47594C43.9686 7.72749 43.3179 8.33544 43.3179 9.572C43.3179 10.8086 44.2203 12.0034 44.346 12.1713C44.4717 12.3392 46.088 14.9576 48.6477 15.965C50.7747 16.8023 51.2076 16.6358 51.6694 16.5939C52.1313 16.5521 53.1593 15.986 53.369 15.3991C53.5787 14.8122 53.5789 14.3093 53.516 14.2042C53.4531 14.0991 53.2852 14.0366 53.0331 13.9108C52.7811 13.785 51.5433 13.1771 51.3125 13.0931C51.0817 13.0092 50.9139 12.9675 50.7458 13.2191C50.5778 13.4706 50.0957 14.0365 49.9488 14.2042C49.8018 14.3719 49.6551 14.393 49.4031 14.2674C49.151 14.1417 48.3402 13.8762 47.378 13.02C46.6295 12.3538 46.1242 11.5311 45.9771 11.2797C45.83 11.0283 45.9615 10.8921 46.0878 10.7669C46.2008 10.6542 46.3395 10.4733 46.4657 10.3266C46.5918 10.18 46.6333 10.0751 46.7172 9.90763C46.801 9.74015 46.7592 9.59305 46.6962 9.46741C46.6332 9.34178 46.1439 8.09866 45.9201 7.60157Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_171_11762",
    x: 37.4139,
    y: 0.888058,
    width: 22.1721,
    height: 22.2238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.482729,
    result: "effect1_foregroundBlur_171_11762"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171_11762",
    x1: 48.268,
    y1: 4.45228,
    x2: 48.3526,
    y2: 18.7421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.cc38799a5d60b43e5c7f6491df7941b9.svg";
export { ForwardRef as ReactComponent };